import { useIcons } from './useIcons';

function isIconBySizes(icon) {
  return !!icon && 'small' in icon && 'medium' in icon;
}

export var useIconAsset = (type, size) => {
  var icons = useIcons();

  var getIconSize = () => {
    switch (size) {
      case 'medium':
      case 'large':
      case 'extra-large':
        return 'medium';

      default:
        return 'small';
    }
  };

  var iconSize = getIconSize();
  var icon = isIconBySizes(icons[type]) ? icons[type][iconSize] : icons[type];
  return icon;
};
//# sourceMappingURL=useIconAsset.js.map